<app-banner-app [retroSelected]=false></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <br><br>
                    <div>
                        <p class="texto2">Lo sentimos</p>
                        <p class="texto1">Tu propiedad presenta una restricción y no puede<br>
                            ser asegurada. Acércate a una oficina de registro o<br>
                            ingresa a la <span class="textoEspecial">web del supernotariado.</span>
                        </p>
                    </div>
                    <br>
                    <img src="./assets/img/Redireccion.png" [width]="1" [height]="1" priority />
                </div>
                <div class="textoAbajo">
                    <img src="./assets/img/Redireccion.png" [width]="1" [height]="1" priority />
                    <br><br><br>
                    <div>
                        <p class="texto2">Lo sentimos</p>
                        <p class="texto1">Tu propiedad presenta una restricción y no puede
                            ser asegurada. Acércate a una oficina de registro o
                            ingresa a la <span class="textoEspecial">web del supernotariado.</span>
                        </p>
                    </div>
                </div>
                <br><br>

                <div class="container tamanioBoton">
                    <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit" (click)="volverInicio()">
                        Volver al inicio
                    </button>
                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>